export const comparisonOperators={
    '$eq':'$eq',
    '$gt':'$gt',
    '$gte':'$gte',
    '$in':'$in',
    '$lt':'$lt',
    '$lte':'$lte',
    '$ne':'$ne',
    '$nin':'$nin',
    '$elemMatch': '$elemMatch',

    '=':'$eq',
    '>':'$gt',
    '>=':'$gte',
    'contains':'$in',
    '<':'$lt',
    '<=':'$lte',
    '!=':'$ne',
    '!contains': '$nin',
    '$all': '$all',
    'all':'$all',
    'regex':'$regex',
    'search':'$search',
    'elemMatch': '$elemMatch',
    'exists':'$exists',
    '$exists':'$exists',
    '==':'=='

}

export const logicalOperators={
    '$and':'$and',
    '$nor':'$nor',
    '$or':'$or',

    '&':'$and',
    '!|':'$nor',
    '|':'$or',
}

export const otherOperators={
    '$not':'$not',
    '!':'$not',
}



